var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "clearfix twoStep",
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "220px",
              },
            },
            [
              _c("el-card", { staticClass: "complaint-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _vm._v(" 投诉编号："),
                    _c("span", [_vm._v(_vm._s(_vm.form.complaintCode))]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "left-complain-con" },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { offset: 4, span: 16 } },
                          [
                            _vm.hasBtnPermission(
                              "online_complaints_btn_handle"
                            ) && _vm.form.receiveStatus == 1
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "受理状态：" } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.dealFn(1)
                                          },
                                        },
                                      },
                                      [_vm._v("受理")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.dealFn(2)
                                          },
                                        },
                                      },
                                      [_vm._v("不予受理")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                class: [
                                  _vm.form.receiveStatus != 1 ? "bgCssBox" : "",
                                ],
                                staticStyle: { "padding-right": "24px" },
                              },
                              [
                                _vm.form.receiveStatus != 1
                                  ? _c(
                                      "el-form-item",
                                      { attrs: { label: "受理状态：" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.form.receiveStatus == 3
                                                ? "受理"
                                                : "不予受理"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.form.receiveStatus == 3
                                  ? [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "受理部门：" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.form.receiverOrgName) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "受理人员：" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.form.receiverName) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "受理时间：" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.form.receiveTime) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm.form.receiveStatus == 2
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "不予受理原因：",
                                            prop: "reasonCode",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                disabled: _vm.isView,
                                                clearable: "",
                                                filterable: "",
                                                placeholder: "请选择",
                                              },
                                              model: {
                                                value: _vm.form.reasonCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "reasonCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.reasonCode",
                                              },
                                            },
                                            _vm._l(
                                              _vm.departmentOptions,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.name,
                                                    title: item.name,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "不予受理回复：",
                                            prop: "reasonReply",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: _vm.isView,
                                              rows: 5,
                                              maxlength: "255",
                                              "show-word-limit": "",
                                              type: "textarea",
                                            },
                                            model: {
                                              value: _vm.form.reasonReply,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "reasonReply",
                                                  $$v
                                                )
                                              },
                                              expression: "form.reasonReply",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._l(
                                        _vm.form.attachments,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            { key: index },
                                            [
                                              !_vm.isView
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: item.fileTypeName
                                                          ? item.fileTypeName +
                                                            "："
                                                          : "附件：",
                                                        prop:
                                                          "attachments" +
                                                          item.fileType,
                                                        size: "small",
                                                      },
                                                    },
                                                    [
                                                      _c("affix-msg", {
                                                        attrs: {
                                                          docItem: item,
                                                          docName: item.name,
                                                        },
                                                        on: {
                                                          "update:docItem":
                                                            function ($event) {
                                                              item = $event
                                                            },
                                                          "update:doc-item":
                                                            function ($event) {
                                                              item = $event
                                                            },
                                                          "update:docName":
                                                            function ($event) {
                                                              return _vm.$set(
                                                                item,
                                                                "name",
                                                                $event
                                                              )
                                                            },
                                                          "update:doc-name":
                                                            function ($event) {
                                                              return _vm.$set(
                                                                item,
                                                                "name",
                                                                $event
                                                              )
                                                            },
                                                          multipleUploadSuccess:
                                                            (data) =>
                                                              _vm.multipleUploadSuccess(
                                                                data,
                                                                index
                                                              ),
                                                          uploadSuccess:
                                                            _vm.uploadSuccess,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("affix-doc", {
                                                    staticClass: "affixDown",
                                                    attrs: {
                                                      item: item,
                                                      name: item.fileTypeName,
                                                      labelWidth: "220px",
                                                    },
                                                    on: {
                                                      "update:item": function (
                                                        $event
                                                      ) {
                                                        item = $event
                                                      },
                                                    },
                                                  }),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ]
                                  : _vm._e(),
                                _c("div", { staticClass: "imgCss" }, [
                                  _vm.form.receiveStatus == 3
                                    ? _c("img", {
                                        attrs: {
                                          src: require("@/assets/img/complaint/ysl.png"),
                                        },
                                      })
                                    : _vm.form.receiveStatus == 2
                                    ? _c("img", {
                                        attrs: {
                                          src: require("@/assets/img/complaint/bysl.png"),
                                        },
                                      })
                                    : _vm._e(),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.form.receiveStatus == 1
                  ? _c("div", { staticClass: "imgCss" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/complaint/dsl.png"),
                        },
                      }),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }